import { Box, Button, Typography, useTheme } from "@mui/material";
import { useWindowDimensions } from "../../utils/mediaQuery";

export const HomeMessage = ({ imageName, text1, text2, button }) => {
  const { width } = useWindowDimensions();
  const theme = useTheme();

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: width < 768 ? "column" : "row",
        justifyContent: "center",
        alignItems: width < 768 ? "center" : "left",
        width: "100%",
        gap: "2rem",
        padding: "2rem",
        borderTop: `4px solid ${theme.palette.grey[300]}`,
      }}
    >
      <Box
        sx={{
          width: width < 768 ? "100%" : "40%",
          borderRadius: "20px",
          overflow: "hidden",
        }}
      >
        <img
          src={`/home/${imageName}.jpg`}
          width={"100%"}
          height={"100%"}
        ></img>
      </Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "left",
          gap: "2rem",
          width: width < 768 ? "100%" : "60%",
          padding: "2rem",
        }}
      >
        <Typography>{text1}</Typography>
        <Typography>{text2}</Typography>
        {button && (
          <Button
            variant="contained"
            color={"primary"}
            onClick={button.onClick}
          >
            {button.label}
          </Button>
        )}
      </Box>
    </Box>
  );
};
